import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { toast } from 'react-toastify';

// CSS de terceros ANTES de App, para que el theme propio (CleanUI.css,
// importado dentro de App) cargue al final y pueda sobrescribirlos.
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';

import "@fullcalendar/core/main.css"
import "@fullcalendar/daygrid/main.css";
// El CSS de timegrid es el que posiciona los eventos en las vistas week/day;
// sin él, los eventos caían fuera de la grilla, al fondo.
import "@fullcalendar/timegrid/main.css";

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { initUpdateChecker } from './updateChecker';

toast.configure({
    autoClose: 1000,
    draggable: false,
    //etc you get the idea
  })


ReactDOM.render(<App />, document.getElementById('root'));

// PWA: registra el service worker (solo en build de producción) para
// cache offline e instalación en pantalla de inicio.
registerServiceWorker();

// Fuerza actualización si hay un deploy más nuevo que el build que corre.
initUpdateChecker();



// WEBPACK FOOTER //
// ./src/index.js